import { useQueryClient } from '@tanstack/react-query';
import { toast } from '@/components/ui/helpers/toast';

import { useAuthenticatedMutation } from '@/hooks/auth/use-auth-query-hooks';
import { invalidateRelatedQueries } from '@/lib/query/cache-invalidation';
import { AccountsApiService } from '@/services/internal-api/accounts/accounts-api-service';

interface RemoveTeamMemberParams {
  accountId: string;
  userId: string;
}

export function useRemoveTeamMember() {
  const queryClient = useQueryClient();

  return useAuthenticatedMutation({
    mutationFn: async ({ accountId, userId }: RemoveTeamMemberParams) => {
      const response = await AccountsApiService.removeUser(accountId, userId);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      toast.success('Team member removed successfully.');
      // Invalidate both teamMembers and USER_ACCOUNTS for consistency
      invalidateRelatedQueries(queryClient, 'TEAM_MEMBERS', { refetchType: 'active' });
      // Also invalidate with specific accountId for exact match
      void queryClient.invalidateQueries({
        queryKey: ['teamMembers', variables.accountId],
        refetchType: 'active',
      });
    },
    onError: (error: any) => {
      console.error('Error removing team member:', error);
      toast.error(error?.response?.data?.message || 'Failed to remove team member.');
    },
  });
}
